import { render, staticRenderFns } from "./IconCoinDown.vue?vue&type=template&id=990f5772&scoped=true&"
import script from "./IconCoinDown.vue?vue&type=script&lang=js&"
export * from "./IconCoinDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990f5772",
  null
  
)

export default component.exports